import { Component } from '@angular/core';

@Component({
  selector: 'cad-footer-public',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.scss'],
})
export class PublicFooterComponent {}
